import styled from "styled-components"

export const RoleHeader = styled.div`
  font-size: 14px;
  padding-bottom: 6px;
`

export const RoleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 0;

  &:last-child {
    border-bottom: none;
  }

  > div:last-child {
    width: 25px;
  }
`

export const RoleTitle = styled.div`
  font-size: 14px;
`

export const RoleDescription = styled.div`
  font-size: 12px;
  font-weight: 300;
  margin-top: 2px;
`
